import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

import { selectServices } from '@repo/api-adapters/selectors/services.selectors';
import type { OrderAsset } from '@repo/types/order';
import { resolveTimezone } from '@repo/utils';

export const getDayBeforeOrderEarliestDeliveryDate = (asset: OrderAsset, storeTimezone: string) => {
    const servicesDates = selectServices(asset);
    const deliveryDatesFromServices = servicesDates.filter((service) => service.isDelivery);

    const deliveryDates = deliveryDatesFromServices
        .map((service) => service.timeWindow?.fromDateTimeUtc)
        .filter((date): date is string => date !== undefined);

    if (deliveryDates.length === 0) {
        return null;
    }

    const orderEarliestDeliveryDate = deliveryDates.reduce((minimumDate: string, currentDate: string) =>
        currentDate < minimumDate ? currentDate : minimumDate
    );

    return dayjs
        .utc(orderEarliestDeliveryDate)
        .tz(resolveTimezone(storeTimezone))
        .subtract(1, 'day')
        .endOf('day')
        .toDate();
};

export const getDatesInRange = (startDate: Dayjs, endDate: Dayjs): Date[] => {
    const totalDays = endDate.startOf('day').diff(startDate, 'day') + 1;

    return Array.from({ length: totalDays }, (_, i) => startDate.add(i, 'day').toDate());
};
